module.exports = __webpack_public_path__ + "media/img/why/reporting-11b2e7912bc1bcf1d707ab30df4eb6a1.png";